import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFamily } from '../lib/family.jsx';
import { verifyPin } from '../lib/pin.js';

/**
 * Picking who's looking at the screen.
 *
 * No sign-in happens here. The guardian's session is untouched; this only
 * changes the lens. A wrong PIN is a wrong door, not a security event — so it
 * says so plainly and lets them try again, with no lockout for a child who
 * typed 7 instead of 1.
 */
export default function Switcher() {
  const { kids, switchToChild, switchToParent } = useFamily();
  const [pending, setPending] = useState(null);
  const [pin, setPin] = useState('');
  const [wrong, setWrong] = useState(false);
  const navigate = useNavigate();

  async function pick(child) {
    if (!child.pin_hash) { switchToChild(child.id); navigate('/'); return; }
    setPending(child); setPin(''); setWrong(false);
  }

  async function confirm(e) {
    e.preventDefault();
    if (await verifyPin(pin, pending.pin_hash)) {
      switchToChild(pending.id);
      navigate('/');
    } else {
      setWrong(true); setPin('');
    }
  }

  if (pending) {
    return (
      <main className="app-shell stack">
        <h1>Hi, {pending.display_name}</h1>
        <form className="card stack" onSubmit={confirm}>
          <label>
            Your PIN
            <input
              type="password" inputMode="numeric" maxLength={4} autoFocus value={pin}
              onChange={(e) => { setPin(e.target.value.replace(/\D/g, '')); setWrong(false); }}
            />
          </label>
          {wrong && <p className="notice warn">That’s not it. Try again.</p>}
          <button className="primary" type="submit" disabled={pin.length < 4}>Open</button>
          <button type="button" className="quiet" onClick={() => setPending(null)}>Not me</button>
        </form>
      </main>
    );
  }

  return (
    <main className="app-shell stack">
      <h1>Who’s flying?</h1>
      <div className="row">
        {kids.map((k) => (
          <button key={k.id} onClick={() => pick(k)} style={{ flex: '1 1 8rem' }}>
            <span className="stack tight">
              <strong>{k.display_name}</strong>
              <span className="small muted">{k.avatar}</span>
            </span>
          </button>
        ))}
      </div>
      <button className="quiet" onClick={() => { switchToParent(); navigate('/'); }}>
        Grown-up view
      </button>
    </main>
  );
}
